module.exports = __webpack_public_path__ + "icon-account.svg?aa30567b7496b71358d565d45a6e0ac5";